$(document).ready(function () {
  function setupFooterAccordion() {
    if ($(window).width() <= 991) {
      $('footer.clFooter .menuBox h3').off('click').on('click', function () {
        var $thisMenuBox = $(this).closest('.menuBox');
        var $thisLinks = $thisMenuBox.find('.menuBoxLinks');
        var $thisSvg = $(this).find('svg');
        $('footer.clFooter .menuBox .menuBoxLinks').not($thisLinks).slideUp();
        $('footer.clFooter .menuBox h3 svg').not($thisSvg).removeClass('rotated');
        $thisLinks.stop(true, true).slideToggle();
        $thisSvg.toggleClass('rotated');
      });
    } else {
      // Desktop: Show all and unbind click
      $('footer.clFooter .menuBox .menuBoxLinks').show();
      $('footer.clFooter .menuBox h3').off('click');
      $('footer.clFooter .menuBox h3 svg').removeClass('rotated');
    }
  }
  setupFooterAccordion();
  $(window).resize(setupFooterAccordion);
});

// Popup Open

// $('.clBtnDrawer').on('click', function() {
//   $('#cl-popup--overlay, #cl-popup--drawer').addClass('active');
// });

document.addEventListener('DOMContentLoaded', function () {

  // Dropdown Link Footer

  const footerDropLink = document.querySelectorAll('a.dropmenu_footer');

  footerDropLink.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const footerDropdown = this.nextElementSibling;

      if(footerDropdown && footerDropdown.classList.contains('menuBoxLinks-detail')){
        this.classList.toggle('active');
        footerDropdown.classList.toggle('active');
      }
    });
  });


  // Accessibility

  const toggleLabel = document.querySelectorAll('.cl-accessibility__toggle-label');
  const mediaElements = document.querySelectorAll('.opacity-05 img, .opacity-05 video');
  const videoFirst = document.querySelector('.video-desktop video');
  const videoSeconde = document.querySelector('.video-mobile video');
  const btmOverlays = document.querySelectorAll('.grid-banner-wrapper .grid-item .grid-image .banner-link, .banner-slide-content');
  const videoOn = document.querySelector('.video-on');
  const videoOff = document.querySelector('.video-pause');

 toggleLabel.forEach(btn => {
  btn.addEventListener('click', function() {
    const isActive = this.classList.toggle('active'); // toggle only clicked button

    // Update media elements
    mediaElements.forEach(el => {
      el.style.filter = isActive ? 'brightness(0.5)' : '';
    });

    // Update videos
    if(isActive){
      videoOff.style.display = 'inline-flex';
      videoOn.style.display = 'none';
      videoFirst.pause();
      videoSeconde.pause();
    } else {
      videoOff.style.display = 'none';
      videoOn.style.display = 'inline-flex';
      videoFirst.play();
      videoSeconde.play();
    }

    // Update all banner overlays
    btmOverlays.forEach(overlay => {
      if(isActive){
        overlay.classList.add('active');
      } else {
        overlay.classList.remove('active');
      }
    });
  });
});


});